import * as Sentry from '@sentry/gatsby'

// Backends del portal: oky-graphql-backend (Apollo) y push-money-public-api
// (REST con axios, ver src/utils/sentryAxiosAdapter.js).
const BACKEND_URLS = [
  process.env.MIDDLE_END_URL,
  process.env.MIDDLE_END_URL_PUSH_MONEY,
].filter(Boolean)

Sentry.init({
  enabled: process.env.SENTRY_ENABLED === 'TRUE',
  dsn: process.env.SENTRY_DSN_KEY,
  environment: process.env.SENTRY_ENVIRONMENT,
  sampleRate: parseFloat(process.env.SENTRY_SAMPLE_RATE),
  tracesSampleRate: parseFloat(process.env.SENTRY_SAMPLE_TRACE),
  replaysSessionSampleRate: parseFloat(process.env.SENTRY_REPLAYSSESSION),
  replaysOnErrorSampleRate: parseFloat(process.env.SENTRY_REPLAYSON),
  debug: process.env.SENTRY_DEBUG === 'TRUE',
  integrations: [
    Sentry.browserTracingIntegration({
      beforeStartSpan: context => {
        // En navegaciones window.location todavía apunta a la ruta anterior:
        // el SDK llama a este hook antes del pushState.
        const pathname = context.name
        const parts = pathname.split('/').filter(part => part)
        const truncatedPathname =
          parts.length > 1 ? `/${parts[0]}/${parts[1]}` : pathname

        return {
          ...context,
          name: truncatedPathname,
        }
      },
    }),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
      networkDetailAllowUrls: [
        'https://graphql.okyapp.com/',
        'https://qa-graphql-backend.okyapp.com/',
      ],
      // Sin esto el replay guarda el body de cada request, con las variables
      // (contraseñas del login, datos bancarios de partners).
      networkCaptureBodies: false,
      networkRequestHeaders: ['X-Custom-Header'],
      networkResponseHeaders: ['X-Custom-Header'],
    }),
    // Solo adjunta el documento de la operación; las variables no se envían.
    Sentry.graphqlClientIntegration({
      endpoints: [process.env.MIDDLE_END_URL].filter(Boolean),
    }),
  ],
  // Los endpoints reales van primero para que la traza llegue a los dos
  // backends en cualquier ambiente, aunque su host no esté en la lista fija.
  tracePropagationTargets: [
    ...BACKEND_URLS,
    'https://graphql.okyapp.com',
    'https://qa-graphql-backend.okyapp.com',
    'https://dev.okyapp.com',
    'https://mi.okyapp.com',
    /^\//,
  ],
  // Cada request a los backends es una transacción y el SDK les adjunta los
  // breadcrumbs, que solo se leen en los errores.
  beforeSendTransaction(event) {
    delete event.breadcrumbs
    return event
  },
})
